var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "#2B65CF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 80,
    rx: 4.85714,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1638 39.6L31.7638 31.24L35.1238 27.88L43.4838 36.24L40.1638 39.6ZM30.0038 39.6C27.1238 39.6 24.6371 38.9733 22.5438 37.72C20.4638 36.4667 18.8571 34.7133 17.7238 32.46C16.6038 30.2067 16.0438 27.5867 16.0438 24.6C16.0438 21.6133 16.6038 18.9933 17.7238 16.74C18.8571 14.4867 20.4638 12.7333 22.5438 11.48C24.6371 10.2267 27.1238 9.6 30.0038 9.6C32.8838 9.6 35.3638 10.2267 37.4437 11.48C39.5371 12.7333 41.1438 14.4867 42.2638 16.74C43.3971 18.9933 43.9638 21.6133 43.9638 24.6C43.9638 27.5867 43.3971 30.2067 42.2638 32.46C41.1438 34.7133 39.5371 36.4667 37.4437 37.72C35.3638 38.9733 32.8838 39.6 30.0038 39.6ZM30.0038 34.48C31.8304 34.5067 33.3504 34.1133 34.5638 33.3C35.7771 32.4867 36.6838 31.3333 37.2838 29.84C37.8971 28.3467 38.2038 26.6 38.2038 24.6C38.2038 22.6 37.8971 20.8667 37.2838 19.4C36.6838 17.9333 35.7771 16.7933 34.5638 15.98C33.3504 15.1667 31.8304 14.7467 30.0038 14.72C28.1771 14.6933 26.6571 15.0867 25.4438 15.9C24.2304 16.7133 23.3171 17.8667 22.7038 19.36C22.1038 20.8533 21.8038 22.6 21.8038 24.6C21.8038 26.6 22.1038 28.3333 22.7038 29.8C23.3171 31.2667 24.2304 32.4067 25.4438 33.22C26.6571 34.0333 28.1771 34.4533 30.0038 34.48Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.75 60C42.8745 60 30 72.8745 30 75.75C30 72.8745 17.1255 60 14.25 60C17.1255 60 30 47.1255 30 44.25C30 47.1255 42.8745 60 45.75 60Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQd);
export default __webpack_public_path__ + "static/media/qd.b2a1fc4cef2714434fcf56778316db16.svg";
export { ForwardRef as ReactComponent };